<template>
  <div>
    <v-tooltip class="locked-field" bottom v-if="!authorizedToBeEdited">
      <template v-slot:activator="{ on }">
        <v-icon class="locked-icon" v-on="on">lock</v-icon>
      </template>
      <span v-html="$t('message.error.notAuthorizedField')"></span>
    </v-tooltip>
    <v-switch
      class="nx-switch"
      v-validate
      :data-vv-name="name"
      :data-vv-scope="scope"
      :data-vv-as="label"
      data-vv-value-path="value"
      :label="label"
      :disabled="disabled"
      v-model="currentValue"
      @change="onChange($event);"
      hide-details
    ></v-switch>
  </div>
</template>

<script>
import FormElementSelection from '@/modules/form/mixins/form-element-selection';
import Authorizable from '@/modules/authorization/mixins/authorizable';

export default {
  name: 'nx-form-switch',
  mixins: [FormElementSelection, Authorizable],
  props: {
    value: {
      type: Boolean,
      default: undefined,
    },
  },
  methods: {
    onDefault(defaultValue) {
      this.$emit('input', defaultValue);
      this.$parentForm.updateField(this.name, defaultValue, { defaultUpdate: true });
      this.$emit('blur', defaultValue);
    },
  },
};
</script>
<style lang="stylus" scoped>
.nx-switch {
  margin-bottom: 18px;
}
.locked-icon {
  float: left;
  margin-top: 3px;
}
</style>
